export var PerkTooltipKind;
(function (PerkTooltipKind) {
    PerkTooltipKind["None"] = "none";
    PerkTooltipKind["WebExclusive"] = "web_exclusive";
    PerkTooltipKind["SubjectToAvailibity"] = "subject_to_availability";
    PerkTooltipKind["OnlyForSpecificRates"] = "only_for_specific_rates";
    PerkTooltipKind["OnlyForRegisterdUsers"] = "only_for_registered_users";
})(PerkTooltipKind || (PerkTooltipKind = {}));
export var PerkLayoutKind;
(function (PerkLayoutKind) {
    PerkLayoutKind["Bullets"] = "bullets";
    PerkLayoutKind["Highlights"] = "highlights";
})(PerkLayoutKind || (PerkLayoutKind = {}));
//# sourceMappingURL=perks.types.js.map